export const create = ({ heads, parseFunc, detailFunc }) => {
  console.assert(heads && heads.length, `헤더가 설정되지 않았습니다.`);
  console.assert(parseFunc, `parseFunc이 정의되지 않았습니다.`);
  return {
    /**
     * 테이블 헤드 텍스트
     */
    head: heads,

    /**
     * 테이블 헤드 키
     */
    headKey: Array.from({ length: heads.length }, (_, i) => `param${i + 1}`),

    /**
     * 테이블 데이터 배열
     *
     * 전달받은 행 데이터를 parse에서 정의한 대로 파싱한다.
     *
     * @param {*} rows
     * @return {Array}
     */
    body: (rows) => {
      return rows?.map((e) => parseFunc(e));
    },

    /**
     * 행을 클릭했을 때 보여줄 상세 정보에서 보여질 데이터
     *
     * 행을 클릭했을 때 body의 정보가 전달된다.
     * @param {*} parsedRow
     * @return {{title: string, contents: any}[]}
     */
    details: (parsedRow) => {
      if (detailFunc) {
        return detailFunc(parsedRow);
      }
      return [];
    },
  };
};
